/**
 * Logo — EZSpot wordmark.
 *
 * Uses DM Serif Display (--font-display) with the blue em accent on "Spot".
 * Renders as a text mark — no image dependency.
 */
import Link from "next/link";
import { cn } from "~/lib/utils";

type LogoProps = {
  className?: string;
  /** Override the rendered font size — default "text-[22px]" */
  sizeClassName?: string;
  href?: string;
  /**
   * "light" — renders "EZ" in white for use on dark/cinematic backgrounds.
   * Default renders "EZ" in var(--ink) for use on light backgrounds.
   */
  variant?: "default" | "light";
};

function WordMark({
  sizeClassName,
  variant = "default",
}: {
  sizeClassName?: string;
  variant?: "default" | "light";
}) {
  return (
    <span
      className={cn(
        "font-display select-none tracking-[-0.02em] leading-none",
        sizeClassName ?? "text-[22px]",
      )}
    >
      <span className={variant === "light" ? "text-white" : "text-(--ink)"}>
        EZ
      </span>
      <em className="not-italic text-(--blue)">Spot</em>
    </span>
  );
}

export function Logo({
  className,
  sizeClassName,
  href,
  variant = "default",
}: LogoProps) {
  if (href) {
    return (
      <Link href={href} className={cn("flex items-center", className)}>
        <WordMark sizeClassName={sizeClassName} variant={variant} />
      </Link>
    );
  }
  return (
    <div className={cn("flex items-center", className)}>
      <WordMark sizeClassName={sizeClassName} variant={variant} />
    </div>
  );
}
